import axios from 'axios'
import laroute from '~/laroute'
import store from '~/store'

export const state = {
  items: [],
  item: {},
  total: 0,
  emptyTags: [],
  transferLogItems: [],
  report: null
}

export const getters = {
  items: state => state.items,
  item: state => state.item,
  total: state => state.total,
  emptyTags: state => state.emptyTags,
  transferLogItems: state => state.transferLogItems,
  report: state => state.report
}

export const mutations = {

  ITEMS (state, data) {
    state.items = data
  },

  ITEM (state, data) {
    state.item = data
  },

  TOTAL (state, data) {
    state.total = data
  },

  EMPTY_TAGS (state, data) {
    state.emptyTags = data
  },

  TRANSFER_LOG_ITEMS (state, data) {
    state.transferLogItems = data
  },

  REPORT (state, data) {
    state.report = data
  }
}

export const actions = {
  async fetchItems ({ commit }, filterData) {
    await axios.get(laroute.route('inventory_count_items', { companyAbbr: store.getters['auth/company'], ...filterData }))
      .then(res => {
        commit('ITEMS', res.data.items)
        commit('TOTAL', res.data.total)
      })
  },

  async fetchEmptyTags ({ commit }, { ...limits }) {
    await axios.get(laroute.route('inventory_count_empty_tags', { companyAbbr: store.getters['auth/company'], ...limits }))
      .then((res) => {
        commit('EMPTY_TAGS', res.data)
      })
  },

  async getTransferLogItems ({ commit }) {
    await axios.get(laroute.route('inventory_count_transfer_log', { companyAbbr: store.getters['auth/company'] }))
      .then((res) => {
        commit('TRANSFER_LOG_ITEMS', res.data)
      })
  },

  async update ({ commit }, { ...item }) {
    await axios.post(laroute.route('inventory_count_update', { companyAbbr: store.getters['auth/company'], id: item.id }), { ...item })
      .then(res => {
        commit('ITEM', res.data.data)
      })
  },

  async create ({ commit }, { ...item }) {
    await axios.post(laroute.route('inventory_count_create', { companyAbbr: store.getters['auth/company'], id: item.id }), { ...item })
      .then(res => {
        commit('ITEM', res.data.data)
      })
  },

  async delete ({ commit }, id) {
    await axios.delete(laroute.route('inventory_count_delete', { companyAbbr: store.getters['auth/company'], id: id }))
  },

  async clearTable () {
    await axios.delete(laroute.route('inventory_count_clear_table', { companyAbbr: store.getters['auth/company'] }))
  },

  async transfer () {
    await axios.post(laroute.route('inventory_count_transfer', { companyAbbr: store.getters['auth/company'] }))
  },

  async getReport ({ commit }, { ...filterData }) {
    const { data } = await axios.get(laroute.route('inventory_count_get_report', { companyAbbr: store.getters['auth/company'], ...filterData }), { responseType: 'arraybuffer' })
    commit('REPORT', data)
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/inventoryCount.js